module.exports = __webpack_public_path__ + "img/bg22.a9ab3ee4.jpeg";